<template>
  <FraisFormation
    :frais-data-par-mode
    :readonly
    :nature-frais="store.lov.NatureFrais"
    :modifie-frais
  />
</template>

<script setup lang="ts">
  import { inject } from 'vue'
  import { DEMANDE_STORE, FraisFormation } from '@/features/interface/demande/shared'
  import { CXPI_MODULES_ACTIONS } from '../../useModuleActions'

  const store = inject(DEMANDE_STORE)!.getStore<'MODEL_CXPI'>()

  const { modifieFrais, readonly, fraisDataParMode } = inject(CXPI_MODULES_ACTIONS)!
</script>
